import { ShieldAlert } from 'lucide-react';
import { Link } from 'react-router';
import { EmptyState } from '@/components';
import { paths } from '@/routing';

/** 403 view for sections the user may not open. */
export function NotAllowed({
  message = 'This section is only available to administrators.',
}: {
  message?: string;
}) {
  return (
    <EmptyState
      icon={<ShieldAlert />}
      title="No access"
      description={message}
      action={<Link to={paths.home()}>Back to projects</Link>}
    />
  );
}
